// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum BuyNowMutationTypes {
    SET_BUY_NOW = 'SET_BUY_NOW',
    SET_CHECKOUT = 'SET_CHECKOUT',
    SET_SELECTED_POLICY = 'SET_SELECTED_POLICY',
  }
  